
export const SUPABASE_CLIENT_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtbWhwY25ycWFrbWNidmxjZXJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjU4MzQ2OTUsImV4cCI6MjA0MTQxMDY5NX0.udVbCIFCBeOWYFhfgIvqXHgOzMD70IJAynT00Pr_oQg';
export const SUPABASE_URL = 'https://rmmhpcnrqakmcbvlcerx.supabase.co';
